export const generations = [
  "Baby Boomer",
  "GenX",
  "Millennials",
  "GenZ",
  "Gen Alpha",
];

export const admins = ["BD2q37ld", "93K2-E2Z", "7sPmIfk_"];
export const defaultpfp =
  "https://10goats.sfo3.cdn.digitaloceanspaces.com/images/pfp/10goats-pfp.png";

// Taste profile cache time (24 hours)
export const TASTE_PROFILE_CACHE_TIME = 3600 * 24;
